module.exports = __webpack_public_path__ + "img/lianm.96accded.png";